<template>
  <div
    class="scss-click-effect style-container ps-3 pe-3 pt-2 pb-2 mb-3 d-flex flex-row"
    @click="goToUrl"
  >
    <div v-if="!hasSlot">
      <span class="ms-1 flex-grow-1 text-start my-auto scss-large-font">
        {{ title }}
      </span>
    </div>
    <slot v-else name="content"></slot>
    <div class="rounded-circle ms-auto style-icon-container">
      <i class="bi bi-chevron-right style-icon"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "RowLabelText",
  props: {
    title: String,
    urlLink: String,
    iconUrl: String,
  },
  computed: {
    hasSlot() {
      return this.$slots.content;
    },
  },
  methods: {
    goToUrl() {
      if (this.urlLink) {
        this.$router.push(this.urlLink);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.style-container {
  width: 90%;
  margin: 0 auto 0 auto;
  height: fit-content;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  border: 1px solid #d1d1d1;
  border-bottom: none;
  box-shadow: 0 2px #c3c3c3;
}

.style-icon-container {
  width: 29px;
  height: 29px;
  border: 1px solid #d1d1d1;
}

.style-icon {
  font-size: 11px;
  -webkit-text-stroke: 1px #4a4a4a;
  position: relative;
  top: 1px;
  left: 0.6px;
}
</style>
